import { useTranslation } from "react-i18next";
import "../../css/Profile/EditProfile.css";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../SessionChecker/SessionChecker";
import { checkingUsername } from "../Signin/CheckingUsername";
import { editProfileRequest } from "./EditProfileRequest";
import {
  handleKeyDownUsernameInput,
} from "../Inputs/handleKeyDown"; 


function EditProfile({ theme }) {
  const { t } = useTranslation();

  const {
    currentUserUsername,
    currentUserFullname,
    currentUserEmail,
    setCurrentUserUsername,
    setCurrentUserFullname,
    setCurrentUserEmail,
    setEmailConfirmStatus,
  } = useContext(AuthContext);

  const [usernameIsBeing, setUsernameIsBeing] = useState(false);

  const [fullnameInputValue, setFullnameInputValue] = useState("");
  const [usernameInputValue, setUsernameInputValue] = useState("");
  const [emailInputValue, setEmailInputValue] = useState("");

  const [requestStatus, setRequestStatus] = useState(false);

  useEffect(() => {
    setFullnameInputValue(currentUserFullname);
    setUsernameInputValue(currentUserUsername);
    setEmailInputValue(currentUserEmail);
  }, [currentUserUsername]);

  return (
    <div className="mainDiv">
      <div className={`headerDiv ${theme}`}>{t("Edit profile")}</div>

      <div className="contentDiv padding12 gap12">
        <div className="inputDiv">
          <div className="lableDiv">{t("Fullname")}</div>
          <input
            className={`input ${theme}`}
            value={fullnameInputValue}
            onChange={(e) => {
              setFullnameInputValue(e.target.value);
            }}

          ></input>
        </div>

        <div className="inputDiv">
          <div className="lableDiv">{t("Username")}</div>
          <input
            className={`input ${theme}`}
            value={usernameInputValue}
            onChange={(e) => {
              setUsernameInputValue(e.target.value);
              checkingUsername(e.target.value, setUsernameIsBeing);

              
            }}
            onKeyDown={(e) => {
              handleKeyDownUsernameInput(e)
            }}
          ></input>
          {usernameIsBeing ? (
            <div className="input_error_div">{t("Is being")}</div>
          ) : (
            ""
          )}
        </div>

        <div className="inputDiv">
          <div className="lableDiv">{t("Email")}</div>
          <input
            className={`input ${theme}`}

            onClick={() => {
              setEmailConfirmStatus(true);
            }} 
            placeholder={currentUserEmail}
          >
            
          </input> 

        </div>

        <button
          className={`submit_button ${theme} ${fullnameInputValue && usernameInputValue && (usernameInputValue != currentUserUsername || fullnameInputValue != currentUserFullname || emailInputValue != currentUserEmail) && "active"}`}
          onClick={() => {
            if (
              fullnameInputValue &&
              usernameInputValue &&
              (usernameInputValue != currentUserUsername ||
                fullnameInputValue != currentUserFullname ||
                emailInputValue != currentUserEmail)
            ) {
              editProfileRequest(
                fullnameInputValue,
                usernameInputValue,
                emailInputValue,
                setRequestStatus,
                setCurrentUserFullname,
                setCurrentUserUsername,
                setCurrentUserEmail,
              );
            }
          }}
        >
          {requestStatus ? (
            <img src="/icons/loading.png" className="rotate"></img>
          ) : (
            t("Submit")
          )}
        </button>
      </div>
    </div>
  );
}

export default EditProfile;
